// src/pages/Accounting/Receipts/components/BenefitsRow.tsx

import React from "react";
import { ScanLine, Link2, ShieldCheck } from "lucide-react";
import { PALETTE } from "../constants";

interface Benefit {
  Icon: React.ComponentType<{ size?: number; strokeWidth?: number }>;
  title: string;
  body: string;
}

const BENEFITS: Benefit[] = [
  {
    Icon: ScanLine,
    title: "Reads + extracts",
    body: "Vendor, date, total, GST or HST, line items pulled from the image.",
  },
  {
    Icon: Link2,
    title: "Matched to transactions",
    body: "Each receipt links to the bank line it belongs to, so every expense has its proof.",
  },
  {
    Icon: ShieldCheck,
    title: "Tax-ready",
    body: "CRA retention compliant. Export by category at tax time; audits stop being a scramble.",
  },
];

export function BenefitsRow() {
  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(3, 1fr)",
        gap: 0,
        marginBottom: 32,
        maxWidth: 920,
      }}
    >
      {BENEFITS.map((b, i) => {
        const Icon = b.Icon;
        const isFirst = i === 0;
        const isLast = i === BENEFITS.length - 1;
        return (
          <div
            key={b.title}
            style={{
              padding: isFirst
                ? "0 24px 0 0"
                : isLast
                ? "0 0 0 24px"
                : "0 24px",
              borderRight: isLast ? "none" : `1px solid ${PALETTE.lineSoft}`,
            }}
          >
            <div
              style={{
                width: 28,
                height: 28,
                borderRadius: 7,
                background: PALETTE.velaFade,
                color: PALETTE.velaDeep,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginBottom: 12,
              }}
            >
              <Icon size={16} strokeWidth={2} />
            </div>
            <h4
              style={{
                fontSize: 13,
                fontWeight: 700,
                margin: "0 0 3px",
                color: PALETTE.ink,
              }}
            >
              {b.title}
            </h4>
            <p
              style={{
                fontSize: 11.5,
                color: PALETTE.ink3,
                margin: 0,
                lineHeight: 1.55,
                fontWeight: 500,
              }}
            >
              {b.body}
            </p>
          </div>
        );
      })}
    </div>
  );
}
